<template>
    <div>
       
        <div class="explain">
        <div style="float:right">
            <div class="g_desktopOn">
            <div style="margin:5px;display:inline-block">
            <s-button @onclick="flagRecept=true" 
                :label="receptCredit + ' CREDITS OFFERTS !'"
                theme="is-success"
                icon="gift"
                v-if="receptCredit>0"
            />
            </div>
             <div style="margin:5px;display:inline-block">
            <s-button @onclick="modalParain=true" theme="is-warning" 
                label="Parrainer  !" icon="hands-helping" />
            &nbsp;
            <s-button @onclick="modalEnvoyerCredit=true" theme="is-primary" 
                label="Envoyer des crédits" icon="paper-plane" />
            </div>
            </div>
         </div>
            <div class="g_mobileOn" >
                <div style="margin-left:10px;" >
                <s-button @onclick="flagRecept=true" 
                    :label="receptCredit + ' CREDITS OFFERTS !'"
                    theme="is-success"
                    icon="gift"
                    v-if="receptCredit>0"
                />
                </div>
                <div style="margin-top:10px;margin-left:10px;">
                <s-button @onclick="modalParain=true" theme="is-warning" 
                    label="Parrainer et gagner des crédits !" icon="hands-helping" />
                </div>
                 <div style="margin-top:10px;margin-left:10px;">
                <s-button @onclick="modalEnvoyerCredit=true" theme="is-primary" 
                    label="Envoyer des crédits" icon="paper-plane" />
                </div>
            </div>
            
       
       
        <s-modal
            title="Récupérer des crédits gratuits !"
            :open="flagRecept"
            :close="true"
            @close="flagRecept = false"
        >
            <div v-for="itemHistorique in historiques" v-if="itemHistorique.recept && itemHistorique.state==null">
                <div style="font-size:18px" v-if="itemHistorique.type=='PARRAINAGE'">
                    Parrainage de {{itemHistorique.userOrigin}}, 
                    Vous avez gagné {{itemHistorique.credit}} crédits
                </div>
                <div style="font-size:18px" v-if="itemHistorique.type=='OFFER'">
                    {{itemHistorique.userOrigin}} a envoyé {{itemHistorique.credit}} crédits
                </div>
                <div style="font-size:18px" v-if="itemHistorique.type=='WELCOME'">
                    Petanque-app vous offre {{itemHistorique.credit}} crédits de bienvenue
                </div>
                 <div style="font-size:18px" v-if="itemHistorique.type=='FILM'">
                    Vous avez regardé une vidéo : Petanque-app vous offre {{itemHistorique.credit}} crédit
                </div>
                <div style="height: 30px;">
                    <div style="float: right">
                        <s-button   label="Accepter"
                                    theme="is-success"
                                    icon="check"
                                    @onclick="accept(itemHistorique.id)"
                        />
                    </div>
                
                </div>
                
                <hr/>
            </div>
        </s-modal>
        <parrainer :open="modalParain" @close="modalParain=false" />
        <send-credit :open="modalEnvoyerCredit" @close="modalEnvoyerCredit=false" @histo="flagSend=true"/>
          <s-modal
            title="Liste de vos envoies de crédits !"
            :open="flagSend"
            :close="true"
            @close="flagSend = false"
        >
            <div v-for="itemHistorique in historiques" v-if="!itemHistorique.recept">
                <div style="font-size:18px">
                   Vous avez envoyé {{itemHistorique.credit}} crédits à  {{itemHistorique.userToSend}} 
                </div>
                <div v-if="itemHistorique.state==true">Il les a bien récupérer</div>
                <div v-if="itemHistorique.state==null">En attente</div>
                <div v-if="itemHistorique.state==false">Il les a refusé !</div>
                <div style="height: 30px; " v-if="itemHistorique.state==null">
                <div style="float: right">
                    <s-button   label="Annuler la demande"
                                theme="is-warning"
                                icon="check"
                                @onclick="cancel(itemHistorique.id, true)"
                    />
                </div>
                </div>
                <hr/>
            </div>
            <div v-if="historiques.length==0">
                Vous n'avez jamais envoyé de crédits
            </div>
        </s-modal>
        <div>
              <s-you-tube id="video_creditAbonnement" :club="club" />
        </div>
        <s-l id="checkout_explain" :v="credit">Votre crédit est de %v concours</s-l>  &nbsp; 
       </div>
        <div class="byMobiyo">
             <div style="margin:5px;display:inline-block">
                 <credits-by-video   />
             </div>
              <div style="width:10px;display:inline-block">
              </div>
             <div style="margin:5px;display:inline-block">
            <s-button 
                label="Obtenez un code et créditez d'un concours" 
                icon="mobile-alt" 
                theme="is-info is-large" 
                @onclick="openMobiyo=true"
                mode="V"/>
             </div>
        </div>
        <div class="byCard">
        ou par carte :
        </div>
        <s-modal
                :open="openMobiyo"
                @close="openMobiyo=false"
                :close="true"
            >
                <mobiyo @close="openMobiyo=false" />
        </s-modal>
           
          
       <waiting :open="openWaiting"/>
       <div style="text-align:center">
           <div class="addCredit">
           <div class="headerAddCredit">
               Achat à l'unité 
           </div>
          
           <div class="explainCredit">
                <input class="input is-primary is-rounded" type="number" v-model="quantity" style="width:80px"/>
                &nbsp;concours
            </div>
            <div class="buttonAdd">
                <s-button icon="credit-card" :disabled="parseInt(quantity)<1" 
                    :label="'Acheter pour '+mount+' €'" 
                
                theme="is-primary is-small" @onclick="addCredit()"/>
            </div>
           
           </div>
           &nbsp;
           
           
            <div class="addCredit">
                <div class="headerAddCredit">
                  <s-l id="pack20">Achat d'un pack de 20 concours</s-l>
                </div>
                <div class="explainCredit">
                    <s-l id="explainpack20">Vous créditez de 20 concours.</s-l>
                </div>
                <div class="buttonAdd">
                    <s-button icon="credit-card" label="pour 30€"  theme="is-primary is-small" @onclick="addCredit(20)"/>
                </div>
                 <div class="_15">1.5 € le concours !!! </div>
            </div>
            <div class="addCredit">
                <div class="headerAddCredit">
                    <s-l id="pack50">Achat d'un pack de 52 concours</s-l>
                </div>
                  <div class="explainCredit">
                       <s-l id="explainpack50">Vous créditez de 52 concours.</s-l>
                </div>
                
                <div class="buttonAdd">
                    <s-button icon="credit-card" label="pour 50€" theme="is-primary is-small" @onclick="addCredit(52)"/>
                </div><br/>
                <div class="_96">0.96 € le concours !!! </div>
            </div>
            
            <div></div>

       </div>
     
    <div class="astuce">
        <div class="headerAstuce">
            <s-l id="explainHeaderAstuce_AbonnerClub">N OUBLIEZ PAS : vous pouvez également abonner votre club !</s-l>
        </div>
        <div class="explainAstuce">
            <s-l id="explainAstuce_AbonnerClub">En abonnant votre club, vous n'avez plus besoin d'utiliser vos crédits pour créer des concours et les personnes que vous avez nommés ADMINISTRATEUR peuvent également en créer. En abonnant votre club, vous pouvez créer autant de concours que vous voulez (dans la limite de l'abonnement et 1 seul par jour).</s-l>
        </div>
        <div style="font-weight:bolder">
            <s-l id="explainAstuce_AbonnerClub2">Pour vous abonner : allez sur votre club et cliquez sur "Abonnez votre club"</s-l>
        </div>
    </div>
    <s-modal
        :open="errorAccept"
        @close="errorAccept=false"
        :close="true"
    >
        <s-l id="errorAcceptSendCredit">Il y a une erreur ... Veuillez recommencer l'opération si c'est possible ... Il se peut que celui qui vous a envoyé les crédits a décidé d'annuler sa demande.</s-l>
    </s-modal>
    </div>
   
</template>
<style scoped>
    ._96 {
        bottom: 10px;
        right: 10px;
        right: 20px;
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        font-size: 22px;
        font-weight: bolder;
        color: white;
        background-color: rgb(9, 209, 9);
        width: 90%;
    }
    ._15 {
        bottom: 10px;
        right: 10px;
        right: 20px;
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        font-size: 22px;
        font-weight: bolder;
        color: white;
        background-color: rgb(156, 209, 9);
        width: 90%;
    }
    .byMobiyo {
       padding-left: auto;
       padding-right: auto;
       width: 100%;
       text-align: center;
    }
     .byCard {
        font-size: 25px;
        font-weight: bolder;
        color: black;
        margin-left: 10px;
    }
    .astuce {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 20px;
        border: thin dashed black;
        background-color: rgb(238, 208, 169);
        color: black;
        font-size: 20px;
        width: 100%;
        text-align: center;
    }
    .headerAstuce {
        padding: 5px;
        background-color: rgb(226, 161, 21);
        color: white;
        font-size: 25px;
        font-weight: bolder;
    }
    .explainAstuce {
        padding: 5px;
        color: black;
    }
    .explainMyCredit {
        font-size: 18px;
          padding: 10px;
    }
    .explain {
        font-size: 22px;
        font-weight: bolder;
        color: black;
       
    }
     .explainCredit {
        padding: 10px;
        font-size: 20px;
        font-weight: bolder;
        color: black;
    }
    .addCredit {
        width: 330px;
        border: thin black dashed;
        padding: 0px;
        display: inline-block;
        vertical-align: top;
        margin: 20px;
        height: 200px;
        position: relative;
    }
    .headerAddCredit {
        background-color: var(--bluebg);
        color:white;
        font-size:18px;
        font-weight: bolder;
        padding: 10px;
    }
    .buttonAdd {
        bottom: 50px;
        right: 10px;
        position: absolute;
    }
    .subscription {
        font-size: 20px;
        font-weight: bolder;
        padding: 10px;
        color: black;
    }
    
</style>
<script >
import credit_fct from "@/firebase/credit"
import subscription_fct from "@/firebase/subscription"
import keys from "@/firebase/keys_firebase"
import axios from "axios"
import firebase from "firebase"
import firebase_api from "@/firebase/firebase_api"
import sendCredit from '@/views/payment/sendCredit.vue'
import parrainer from '@/views/payment/parrainer.vue'
import mobiyo from '@/views/payment/mobiyo.vue'
import creditsByVideo from '@/views/payment/creditsByVideo.vue'

try {
  var stripe = Stripe(keys.keys.stripe.pk);
} catch (error) {
  
}
export default {
    data() {
        return {
            urlWeb: "https://europe-west1-petanktest-966f4.cloudfunctions.net/CreatePaymentIntent/",
            quantity: 1,
            openWaiting: false,
            club: null,
            openAbonnement: false,
            modalEnvoyerCredit: false,
            historiques : [],
            flagRecept: false,
            flagSend: false,
            openMobiyo: false,
            errorAccept: false,
            modalParain: false
        }
    },
    components: {
        sendCredit,
        mobiyo,
        creditsByVideo,
        parrainer
    },
    computed:
    {   
        credit: {
          get() {
            
            if (this.$store.getters.getCredit == null)
              return 0;
            else
              return this.$store.getters.getCredit.credit
          },
        },
        mount: {
            get() {
                return 2 * this.quantity;
            }
        },
         clubIsSubscription: {
             get() {
                if (this.club !=null) {
                if (typeof(this.club.subscription) != "undefined")
                        if (this.club.subscription.status == "active") {
                            var date = new Date();
                            var endDate = this.club.subscription.period_end.toDate();
                            var startDate =  this.club.subscription.period_start.toDate();
                            endDate.setDate(endDate.getDate() + 7);
                            if (startDate < date && date < endDate)
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    else
                        false;
                 }
             }
        },
        receptCredit: {
            get() {
                var recept = 0;
                this.historiques.forEach(item=>{
                    if (item.state == null && item.recept)
                        recept += parseInt(item.credit);
                })
                return recept;
            }
        }
    },
    mounted() {
        var idClub = this.$route.params.id;
        if (typeof(idClub)!="undefined")
            this.$bind("club", firebase_api.api.getDb().collection("club").doc(idClub))
        this.$bind("historiques", firebase_api.api.getDb().collection("user").
            doc(this.$store.getters.getUser.email).collection("creditsOffer"))
    },
    methods: {
        closeHistorique() {
            this.flagRecept=false;
            this.flagSend=false;
        },
         cancel(id) {
            const functions = firebase.app().functions('europe-west1');
            const params =  {
                id: id
            }
            this.openWaiting = true;
            functions.httpsCallable("cancelCredit")(params).then(res=>{
             
                this.openWaiting = false;

                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
        },
        accept(id) {
            const functions = firebase.app().functions('europe-west1');
            const params =  {
                id: id
            }
            this.openWaiting = true;
            functions.httpsCallable("acceptCredit")(params).then(res=>{
                this.flagRecept = false;
                this.openWaiting = false;
                this.errorAccept = !res.data;
                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
        },
        addCredit(pack) {
            var quantity = 1;
            
            if (typeof(pack) == "undefined") {
                var priceId = keys.keys.stripe.price_concours_id;
                quantity = this.quantity;
                pack = 1;
            }
            else if (pack==20) {
                var priceId = keys.keys.stripe.price_pack20_id;
            }
            else if (pack==52)
                var priceId = keys.keys.stripe.price_pack52_id;
            
            var idClub = this.$route.params.id;
            
            if (typeof(idClub)!="undefined") {
                var successUrl = window.location.origin + '/club/' + idClub;
                var cancelUrl = window.location.origin + '/club/' + idClub;
            }
            else {
                var successUrl = window.location.origin + '/payment';
                var cancelUrl = window.location.origin+ '/payment';
            }
            var idAuth = this.$store.getters.getUser.authId;
           
            
            const functions = firebase.app().functions('europe-west1');
           
            const params =  {
                quantity: quantity,
                priceId: priceId,
                success_url: successUrl,
                cancel_url: cancelUrl
            }
            
            this.openWaiting = true;
            functions.httpsCallable("addCredit")(params).then(res=>{
                
                //stripe.redirectToCheckout({ sessionId });
                stripe.redirectToCheckout({
                    sessionId: res.data.message
                })
                .then((result)=> {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                    
                });
            });
            
        }
    }
}
</script>